import React, { useState, type ReactNode } from 'react';

import type { Company } from 'modules/app/hooks/useCompany';

import {
  type GringottsNavigation,
  GringottsIframe,
} from '../../components/GringottsIframe/GringottsIframe';

interface Props {
  companyId: string;
  bankingProvider: Company['banking_provider'];
  children(
    openGringotts: (navigation?: GringottsNavigation) => void,
  ): ReactNode;
}

export const GringottsContainer = ({
  companyId,
  bankingProvider,
  children,
}: Props) => {
  const [gringottsState, setGringottsState] = useState<{
    isOpen: boolean;
    navigation?: GringottsNavigation;
  }>({
    isOpen: false,
    navigation: undefined,
  });

  const openGringotts = (navigation?: GringottsNavigation) => {
    setGringottsState({
      isOpen: true,
      navigation,
    });
  };

  const closeGringotts = () => {
    setGringottsState({
      isOpen: false,
      navigation: undefined,
    });
  };

  return (
    <>
      {children(openGringotts)}
      {gringottsState.isOpen && (
        <GringottsIframe
          companyId={companyId}
          bankingProvider={bankingProvider}
          navigation={gringottsState.navigation}
          onClose={closeGringotts}
        />
      )}
    </>
  );
};
